module.exports = __webpack_public_path__ + "static/zwyzka-teleskopowa-agata-meble-szyldy-reklamowe-dff1393c243e8bb64520ba9e72dc3e23.jpg";